import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { filter } from 'lodash';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import { useNavigationContext } from '../context';
import { ItemBaseUI, ItemUI } from '../styles/navigation-styles';
export default function NavigationSearchNoResultsFound(_ref) {
  var search = _ref.search;

  var _useNavigationContext = useNavigationContext(),
      items = _useNavigationContext.navigationTree.items;

  var resultsCount = filter(items, '_isVisible').length;

  if (!search || !!resultsCount) {
    return null;
  }

  return createElement(ItemBaseUI, null, createElement(ItemUI, null, __('No results found.'), " "));
}
//# sourceMappingURL=search-no-results-found.js.map